import { fetchUser } from "services/userServices";

export const getUserFirstName = async (): Promise<string | null> => {
  try {
    const user = await fetchUser();
    const fullName = user.name;
    const firstNameRaw = fullName.split(" ")[0];
    const firstName =
      firstNameRaw.charAt(0).toUpperCase() + firstNameRaw.slice(1).toLowerCase();

    localStorage.setItem("firstName", firstName);
    return firstName;
  } catch {
    return null;
  }
};

export const getUserName = async (): Promise<string | null> => {
  try {
    const user = await fetchUser();
    return user.username;
  } catch {
    return null;
  }
};


